import { frontendURL } from 'dashboard/helper/URLHelper';
import CommissionsView from './CommissionsView.vue';
import MyCommissionsView from './MyCommissionsView.vue';
import CommissionsSkyView from './CommissionsSkyView.vue';
import MyCommissionsSkyView from './MyCommissionsSkyView.vue';

const COMMISSIONS_PERMISSIONS = ['administrator', 'agent'];
// "Minhas Comissões" é p/ consultores, que costumam ter custom role (ex.: "Agente Restrito").
// Incluir 'custom_role' faz o item aparecer/abrir p/ esses usuários (mesmo padrão da Agenda).
// O dado é escopado por user no backend, então é seguro liberar amplamente aqui.
const MY_COMMISSIONS_PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/commissions'),
    name: 'commissions_view',
    meta: {
      permissions: COMMISSIONS_PERMISSIONS,
    },
    component: CommissionsView,
  },
  {
    path: frontendURL('accounts/:accountId/my-commissions'),
    name: 'my_commissions_view',
    meta: {
      permissions: MY_COMMISSIONS_PERMISSIONS,
    },
    component: MyCommissionsView,
  },
  {
    path: frontendURL('accounts/:accountId/commissions-sky'),
    name: 'commissions_sky_view',
    meta: {
      permissions: COMMISSIONS_PERMISSIONS,
    },
    component: CommissionsSkyView,
  },
  {
    path: frontendURL('accounts/:accountId/my-commissions-sky'),
    name: 'my_commissions_sky_view',
    meta: {
      permissions: MY_COMMISSIONS_PERMISSIONS,
    },
    component: MyCommissionsSkyView,
  },
];
